module.exports = __webpack_public_path__ + "img/Uebersicht_Ohr_Außen.bc5444cb.jpg";